import React, { useEffect, useState } from "react";
import { GoHomeFill, GoOrganization } from "react-icons/go";
import { GrDocumentVerified } from "react-icons/gr";
import {
  MdOutlineAccountBalanceWallet,
  MdDescription,
  MdLocalShipping,
} from "react-icons/md";
import { FaUsers } from "react-icons/fa";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
// import { useAlert } from "react-alert";
import { useAlert } from "../../components/UI_components/Alert";
import { BASE_URL, environment } from "../../utils/constant";
import { MdArrowDropDown } from "react-icons/md";
import { MdOutlineArrowDropUp } from "react-icons/md";
import { BsThreeDotsVertical } from "react-icons/bs";
import { GoPlus } from "react-icons/go";
import userImage from "../../assets/3d_avatar_26.png";
import { IoChatbubbles } from "react-icons/io5";
import { TeamsModal, AccessManagementModal } from "./TeamManagement";
import { rtdb } from "utils/firebase";
import { useNavigate } from "react-router-dom";
import { useLocation, useParams } from "react-router-dom";
const Sidebar = ({ setTab, siteId, userPermissions, setTriggerRefresh }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [site, setSite] = useState({});
  const [showTeams, setShowTeams] = useState(true);
  const [teams, setTeams] = useState([]);
  const [showTeamsModal, setShowTeamsModal] = useState(false);
  const [showAccessModal, setShowAccessModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [gpsEnabled, setGpsEnabled] = useState(false);
  const [isOwner, setIsOwner] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const getCurrentTab = () => {
    const pathSegments = location.pathname.split("/");

    // Map URL paths to tab IDs
    const pathToTabMap = {
      home: "Home",
      tasks: "Tasks",
      finance: "Finance",
      materials: "Materials",
      workers: "Workers",
      report: "Report",
      snags: "Snags",
      details: "Details",
      "task-details": "TaskDetails",
      "document-manager": "Document Manager",
    };

    // Find the first segment that matches a known tab path
    for (const segment of pathSegments) {
      if (pathToTabMap[segment]) {
        return pathToTabMap[segment];
      }
    }

    return "Home";
  };

  const selected = getCurrentTab();

  const setSiteGPSPreference = async (siteId, enabled) => {
    try {
      await rtdb
        .ref(`GPSPreferences-${environment}/Sites/${siteId}`)
        .set(enabled);
      return true;
    } catch (error) {
      console.error("Error setting GPS preference:", error);
      return false;
    }
  };

  const getSiteGPSPreference = async (siteId) => {
    try {
      const snapshot = await rtdb
        .ref(`GPSPreferences-${environment}/Sites/${siteId}`)
        .once("value");
      const enabled = snapshot.val();
      return enabled !== null ? enabled : false; // Default to false if not set
    } catch (error) {
      console.error("Error getting GPS preference:", error);
      return false;
    }
  };

  useEffect(() => {
    const fetchGPSPreference = async () => {
      const siteId = localStorage.getItem("site");
      const enabled = await getSiteGPSPreference(siteId);
      setGpsEnabled(enabled);
    };

    fetchGPSPreference();
  }, []);

  const handleGPSToggle = async () => {
    const siteId = localStorage.getItem("site");
    const newGpsEnabled = !gpsEnabled;
    setGpsEnabled(newGpsEnabled);
    await setSiteGPSPreference(siteId, newGpsEnabled);
    setTriggerRefresh((prev) => prev + 1);
  };

  const user = JSON.parse(localStorage.getItem("user"));
  const { addAlert } = useAlert();

  const handleMemberClick = (member) => {
    // Only show access modal if user is owner
    // console.log("teams", teams);
    // console.log("current user:", user);
    const currentMember = teams.find((t) => t.user_id === user.user);
    console.log("current member:", currentMember);
    if (currentMember?.is_admin || currentMember?.joined_as === "owner") {
      console.log("member clicked:", member);
      setSelectedMember(member);
      setShowTeamsModal(false);
      setShowAccessModal(true);
    }
  };

  const getUserDetails = async () => {
    const accessToken = localStorage.getItem("access");
    if (accessToken) {
      const response = await fetch(`${BASE_URL}/auth/user-details-of-user/`, {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        }),
      });
      const data = await response.json();
      if (data?.status) {
        setIsOwner(data?.data?.profession === "owner");
      }
    }
  };

  const getSite = async () => {
    try {
      const accessToken = localStorage.getItem("access");
      const siteId = localStorage.getItem("site");

      if (accessToken && siteId) {
        const response = await fetch(
          `${BASE_URL}/sites/get-a-sites/${siteId}/`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        const data = await response.json();
        if (data.status) {
          setSite(data.data);
        } else {
          throw new Error(data.message);
        }
      }
    } catch (error) {
      addAlert("Error fetching site", "error");
    }
  };

  const getTeamMembers = async () => {
    try {
      const accessToken = localStorage.getItem("access");
      const siteId = localStorage.getItem("site");
      const organizationId = JSON.parse(
        localStorage.getItem("organization")
      )?.id;

      if (accessToken && siteId) {
        const [teamRes, orgRes] = await Promise.all([
          fetch(`${BASE_URL}/team/list-site-members/${siteId}/`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
          }),
          organizationId
            ? fetch(`${BASE_URL}/org/organization/${organizationId}/members/`, {
              method: "GET",
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
            })
            : Promise.resolve({
              ok: true,
              json: async () => ({ status: true, data: [] }),
            }),
        ]);

        const teamData = await teamRes.json();
        const orgData = await orgRes.json();

        if (teamData.status) {
          const orgMembersById = Array.isArray(orgData?.data)
            ? orgData.data.reduce((acc, orgMember) => {
              acc[orgMember.id] = orgMember;
              return acc;
            }, {})
            : {};

          const enriched = (teamData.data || []).map((tm) => {
            const orgMember = orgMembersById[tm.organization_member_id];
            if (!orgMember) return tm;
            return {
              ...tm,
              user: tm.user || orgMember.user,
              profession: tm.profession || orgMember?.user?.profession,
            };
          });
          setTeams(enriched);
        } else {
          throw new Error(teamData.message);
        }
      }
    } catch (error) {
      addAlert("Error fetching teams", "error");
    }
  };

  useEffect(() => {
    getSite();
    getTeamMembers();
    getUserDetails(); // Fetch user details to check if owner
  }, [localStorage.getItem("site"), localStorage.getItem("access")]);

  useEffect(() => {
    const saved = localStorage.getItem("projectSidebarCollapsed");
    if (saved !== null) {
      setIsCollapsed(saved === "true");
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("projectSidebarCollapsed", isCollapsed ? "true" : "false");
  }, [isCollapsed]);

  const isTeamListVisible = isCollapsed || showTeams;

  return (
    <div
      className={`relative ${isCollapsed ? "w-[80px]" : "w-[268px]"} h-[92vh] pb-12 bg-white border-r border-gray-100 py-2`}
      style={{
        // overflowY: "scroll",
        // overflowX:"visible"
      }}
    >
      <button
        onClick={() => setIsCollapsed((prev) => !prev)}
        title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        className="absolute -right-4 top-[45%] z-50 h-12 w-4 rounded-r-md bg-white border-y-[1px] border-r-[1px] border-gray-200 flex items-center justify-center hover:bg-gray-50"
      >
        {isCollapsed ? (
          <FaChevronRight className="text-[#3B0069]" size={10} />
        ) : (
          <FaChevronLeft className="text-[#3B0069]" size={10} />
        )}
      </button>

      <nav className={`gap-2 flex flex-col h-full ${isCollapsed ? "px-1" : "px-3"}`} style={{
        overflowY: "auto",
        scrollbarWidth: "none",
      }}>
        {[
          { id: "Home", icon: GoHomeFill, label: "Dashboard", path: "home" },
          {
            id: "Materials",
            icon: MdLocalShipping,
            label: "Materials",
            path: "materials",
          },
          {
            id: "Tasks",
            icon: GrDocumentVerified,
            label: "Tasks",
            path: "tasks",
          },
          {
            id: "Finance",
            icon: MdOutlineAccountBalanceWallet,
            label: "Finance",
            path: "finance",
          },
          { id: "Workers", icon: FaUsers, label: "Workers", path: "workers" },
          {
            id: "Report",
            icon: MdDescription,
            label: "Daily Report",
            path: "report",
          },
          // {
          //   id: "Document Manager",
          //   icon: MdDescription,
          //   label: "Document Manager",
          //   path: "document-manager",
          // },
          { id: "Snags", icon: IoChatbubbles, label: "Snags", path: "snags" },
        ].map(({ id, icon: Icon, label, path }) => (
          <div
            key={id}
            onClick={() => setTab(path)}
            title={label}
            className={`
              relative group flex items-center ${isCollapsed ? "justify-center " : ""} px-3 py-3 text-sm font-medium rounded-lg
              cursor-pointer transition-all duration-200 ease-in-out
              ${selected === id
                ? "text-[#3B0069] bg-purple-50"
                : "text-gray-500 hover:text-[#3B0069] hover:bg-purple-50/50"
              }
            `}
          >
            <div
              className={`
                absolute left-0 top-1/2 -translate-y-1/2 w-1 h-5
                rounded-r transition-all duration-200 ease-in-out
                ${selected === id
                  ? "bg-[#3B0069] scale-y-100"
                  : "bg-[#3B0069]/0 scale-y-0 group-hover:bg-[#3B0069]/50 group-hover:scale-y-75"
                }
              `}
            />

            <Icon
              className={`
              w-5 h-5 ${isCollapsed ? "" : "mr-3"} transition-colors duration-200
              ${selected === id
                  ? "text-[#3B0069]"
                  : "text-gray-400 group-hover:text-[#3B0069]"
                }
            `}
            />

            {!isCollapsed && <span className="font-medium">{label}</span>}
          </div>
        ))}
        {!isCollapsed && (
          <div className="flex flex-row items-center px-1 py-1 justify-between">
            <div
              className="flex flex-row items-center gap-2 cursor-pointer"
              onClick={() => {
                setShowTeams(!showTeams);
              }}
            >
              {!showTeams ? (
                <MdOutlineArrowDropUp className="h-5 w-5" fill="#8D8D8D" />
              ) : (
                <MdArrowDropDown className="h-5 w-5" fill="#8D8D8D" />
              )}
              <p className="text-[#3B0069] text-[16px] font-bold">Teams</p>
            </div>
            {/* <BsThreeDotsVertical className="text-black h-4 w-4" /> */}
          </div>
        )}
        {/* {isOwner && (
          <div className="flex items-center px-2 mb-2 border-b-[1px] border-[#D4D6D9] py-2 justify-between">
            <span className="text-gray-600">GPS tracking</span>
            <div
              className={`${
                gpsEnabled ? "bg-purple-900" : "bg-gray-500"
              } w-12 h-6 rounded-full relative cursor-pointer`}
              onClick={() => {
                handleGPSToggle();
              }}
            >
              {gpsEnabled ? (
                <div className="absolute right-1 top-1 bg-white w-4 h-4 rounded-full" />
              ) : (
                <div className="absolute left-1 top-1 bg-white w-4 h-4 rounded-full" />
              )}
            </div>
          </div>
        )} */}
        {isTeamListVisible && (
          <div className={`flex ${isCollapsed ? "flex-col items-center gap-2 pt-1" : "flex-col gap-2"}`}>
            {userPermissions?.member_control && (
              <button
                type="button"
                onClick={() => setShowTeamsModal(true)}
                title="Add new member"
                className={`${isCollapsed
                  ? "flex items-center justify-center  rounded-full  border border-purple-100"
                  : "flex flex-row items-center py-2 mb-4 hover:bg-purple-50 justify-center gap-2 w-full rounded-lg cursor-pointer border-1 border-text-clr"
                  }`}
              >
                <div className="p-2 rounded-full bg-[#ECE6F0] hover:bg-purple-100">
                  <GoPlus className="text-[#3B0069] h-4 w-4" />
                </div>
                {!isCollapsed && (
                  <p className="text-text-clr text-[14px] font-medium">
                    Add New Member
                  </p>
                )}
              </button>
            )}
            {teams.map((team) => (
              <div
                key={team.id}
                title={`${team.first_name || ""} ${team.last_name || ""}`.trim()}
                onClick={() => {
                  if (
                    userPermissions?.member_control ||
                    userPermissions?.is_admin
                  ) {
                    handleMemberClick(team);
                  }
                }}
                className={`${isCollapsed
                  ? "flex items-center justify-center p-1 w-full"
                  : "flex flex-row items-start justify-between w-full bg-white rounded-lg cursor-pointer"
                  }`}
              >
                <div className={`${isCollapsed ? "flex items-center justify-center w-full" : "flex flex-row gap-2 items-center"}`}>
                  {team.userpic ? (
                    <div className="flex items-center justify-center bg-[#3B0069] rounded-full w-8 h-8">
                      <img
                        src={team.userpic}
                        alt="Team member"
                        className="w-full h-full rounded-full object-cover"
                      />
                    </div>
                  ) : (
                    <div className="flex items-center justify-center bg-[#3B0069] rounded-full w-8 h-8 text-white text-sm font-semibold uppercase">
                      {(team.first_name ? team.first_name[0] : "") + (team.last_name ? team.last_name[0] : "")}
                    </div>
                  )}
                  {!isCollapsed && (
                    <div className="flex flex-col items-start justify-start">
                      <p className="text-[#1C1C1C] text-[14px] font-normal">
                        {team.first_name} {team.last_name}{" "}
                        {team?.user_id === user?.user ? "(You)" : ""}
                      </p>
                      <p className="text-[#737373] text-[12px] font-normal">
                        ({team?.is_admin === true ? "Admin" : "Member"})
                      </p>
                    </div>
                  )}
                </div>
                {isOwner && !isCollapsed && (
                  <BsThreeDotsVertical className="text-black h-4 w-4" />
                )}
              </div>
            ))}
          </div>
        )}
      </nav>
      {showTeamsModal && (
        <TeamsModal
          teams={teams}
          onClose={() => {
            setShowTeamsModal(false);
            getTeamMembers();
          }}
          onMemberClick={handleMemberClick}
        />
      )}

      {showAccessModal && selectedMember && (
        <AccessManagementModal
          member={selectedMember}
          onClose={() => setShowAccessModal(false)}
          onSave={getTeamMembers}
        />
      )}
    </div>
  );
};

export default Sidebar;
